// components/CustomToaster.jsx
import { Toaster } from 'react-hot-toast';

const CustomToaster = () => (
  <Toaster
    position="top-right"
    reverseOrder={false}
    toastOptions={{
      duration: 3000,
      style: {
        background: '#9333EA', // purple-600
        color: '#fff',
         fontFamily: "'Inter', sans-serif",
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        padding: '16px 24px',
        fontSize: '14px',
        borderLeft: '4px solid #7e22ce', // a slightly darker purple (close to purple-700)
      },
      success: {
        style: {
          background: '#9333EA',
          borderLeft: '4px solid #7e22ce',
        },
        iconTheme: {
          primary: '#fff',
          secondary: '#9333EA',
        },
      },
      error: {
  style: {
    background: '#B91C1C', // Tailwind red-700
    borderLeft: '4px solid #991B1B', // Tailwind red-800
  },
  iconTheme: {
    primary: '#fff',
    secondary: '#B91C1C',
  },
},

      loading: {
        style: {
          background: '#3B82F6',
          borderLeft: '4px solid #2563EB',
        },
      },
      custom: {
        style: {
          background: '#333',
          borderLeft: '4px solid #111',
        },
      },
    }}
  />
);

export default CustomToaster;
